import React, { useState, useRef } from 'react';
import ComingSoonPage from './ComingSoonPage';

export default function Chat() {
    const [users, setUsers] = useState([
        { id: 1, photo: '/assets/player/player1.svg', name: 'John Doe', unread: 2, messages: [] },
        { id: 2, photo: '/assets/player/player2.svg', name: 'Jane Smith', unread: 0, messages: [] }
    ]);
    const [selectedUserId, setSelectedUserId] = useState(1);
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);

    const selectedUser = users.find(user => user.id === selectedUserId);

    const handleSend = () => {
        if (!message && !file) return;

        const newMsg = {
            text: message,
            file: file,
            fromMe: true,
            time: new Date().toLocaleTimeString()
        };

        const replyMsg = {
            text: 'Auto-reply: Got it!',
            fromMe: false,
            time: new Date().toLocaleTimeString()
        };

        setUsers(prev =>
            prev.map(user =>
                user.id === selectedUserId
                    ? {
                        ...user,
                        messages: [...user.messages, newMsg, replyMsg],
                        unread: 0
                    }
                    : user
            )
        );

        setMessage('');
        setFile(null);
    };

    const handleSelectUser = (id) => {
        setSelectedUserId(id);
        setUsers(prev =>
            prev.map(user =>
                user.id === id ? { ...user, unread: 0 } : user
            )
        );
    };

    return (
        <div className='mt-5' data-aos='fade-in' data-aos-duration='1000'>
            <ComingSoonPage />
            <p className='text-xl font-medium tracking-widest uppercase'>CHAT & NEGOTIATIONS</p>
            <div className='flex flex-col lg:flex-row gap-7 mt-5'>
                <div className='w-full lg:w-[30%]'>
                    <div className='border rounded-full flex items-center'>
                        <input
                            type='search'
                            placeholder='SEARCH PLAYER'
                            className='placeholder:text-white bg-transparent rounded-full py-2 px-3 outline-none w-full'
                        />
                        <img src='/assets/icon/searchicon.svg' className='mx-3' />
                    </div>
                    <div className='mt-5 h-[500px] w-full border rounded-3xl overflow-y-auto'>
                        {users.map(user => (
                            <div
                                key={user.id}
                                onClick={() => handleSelectUser(user.id)}
                                className={`p-4 cursor-pointer hover:bg-white/10 flex justify-between items-center ${user.id === selectedUserId ? 'bg-white/10' : ''
                                    }`}
                            >
                                <div className='flex items-center gap-3'>
                                    <img src={user.photo} className='w-10 h-10 rounded-full'></img><span>{user.name}</span>
                                </div>
                                {user.unread > 0 && (
                                    <span className='bg-red-500 text-white rounded-full px-2 text-xs'>
                                        {user.unread}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className='w-full lg:w-[70%] overflow-hidden relative'>
                    <div className='relative flex flex-col border border-white/10 rounded-3xl h-[562px] bg-[#8989890D] overflow-hidden'>
                        <div className='flex gap-3 justify-between items-center p-4 '>
                            <div className='flex items-center w-full lg:w-auto gap-3'>
                                <img src={selectedUser?.photo} className='w-12 h-12 hidden lg:block rounded-full border' alt='User' />
                                <span className='font-medium text-lg uppercase'>{selectedUser?.name}</span>
                            </div>
                            <div>
                                <button className='p-[1px] bg-gradient-to-r from-white to-[#5C1FE2] rounded-full'>
                                    <button className='rounded-full px-5 py-1 font-semibold bg-black'>Send Contract</button>
                                </button>
                            </div>
                        </div>
                        <div className='flex-1 p-4 overflow-y-auto'>
                            {selectedUser?.messages?.map((msg, index) => (
                                <div
                                    key={index}
                                    className={`mb-3 flex ${msg.fromMe ? 'justify-end' : 'justify-start'}`}
                                >
                                    <div className={`max-w-xs px-4 py-2 relative rounded-t-lg ${msg.fromMe ? 'bg-[#2F1073] rounded-l-lg' : 'rounded-r-lg bg-white/10'}`}>
                                        {msg.text && <p className='text-sm'>{msg.text}</p>}
                                        {msg.file && (
                                            <div className='mt-2'>
                                                <a
                                                    href={URL.createObjectURL(msg.file)}
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    className='text-white underline text-sm'
                                                >
                                                    {msg.file.name}
                                                </a>
                                            </div>
                                        )}
                                        <div className='text-right text-[10px] text-white/60 mt-1'>{msg.time}</div>
                                        <div className={`w-2 h-2 absolute send-tri bottom-0 ${msg.fromMe ? 'bg-[#2F1073] -right-2' : 'bg-white/10 -left-2 scale-x-[-1]'}`} ></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='p-3 flex items-center gap-2'>
                            <div className='flex bg-white/15 rounded-md w-full'>
                                <div className='flex items-center'>
                                    <input
                                        type='file'
                                        className='hidden'
                                        ref={fileInputRef}
                                        onChange={(e) => setFile(e.target.files[0])}
                                    />
                                    <button
                                        onClick={() => fileInputRef.current.click()}
                                        className='pl-3 py-1 rounded-full'
                                    >
                                        📎
                                    </button>
                                </div>
                                <input
                                    type='text'
                                    className='w-full bg-transparent placeholder:text-white rounded-full px-4 py-2 outline-none'
                                    placeholder='Type your message...'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                            </div>
                            <button
                                onClick={handleSend}
                                style={{ background: 'linear-gradient(90deg, #2F1073 0%, #5C1FE2 50.48%, #5C1FE2 72.41%, #2F1073 100%)' }}
                                className='text-white px-3 lg:px-10 py-2 rounded-full'  >
                                Send
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            {<style>
                {`
                .send-tri {
                clip-path: polygon(0 0, 0% 100%, 100% 100%);
                }
                `}
            </style>}
        </div>
    );
}
